import { render, staticRenderFns } from "./indexCategorySelector.vue?vue&type=template&id=ffa7f3c4&scoped=true&"
import script from "./indexCategorySelector.vue?vue&type=script&lang=js&"
export * from "./indexCategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./indexCategorySelector.vue?vue&type=style&index=0&id=ffa7f3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa7f3c4",
  null
  
)

export default component.exports